import {ValidationOptions} from '@modifi/plugin-forms'
import {
  COMMON_VALIDATION_RULES,
  INTERMEDIARY_SHAREHOLDER_STREET_NAME,
  INTERMEDIARY_SHAREHOLDER_VOTING_SHARE,
  TRADE_PARTNER_MAXIMUM_PAYMENT_TERM,
} from '@modifi/plugin-onboarding'

const RULES: Record<string, ValidationOptions> = {
  ...COMMON_VALIDATION_RULES,

  [TRADE_PARTNER_MAXIMUM_PAYMENT_TERM]: {
    minValue: 5,
    maxValue: 200,
    optional: true,
  },

  intermediaryBankCode: {
    optional: true,
    minLength: 8,
    maxLength: 11,
  },

  [INTERMEDIARY_SHAREHOLDER_STREET_NAME]: {
    minLength: 4,
    maxLength: 128,
  },
  [INTERMEDIARY_SHAREHOLDER_VOTING_SHARE]: {
    minValue: 1,
  },
}

export default RULES
